import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: 200,
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	},
}));

const ModalImageCors = ({ imageUrl, message }) => {
	const classes = useStyles();

	// ✅ FUNCIÓN PARA RENDERIZAR REACCIONES SOBRE LA IMAGEN
	const renderImageReactions = () => {
		if (!message?.reactions || message.reactions.length === 0) {
			return null;
		}

		// ✅ MOSTRAR SOLO LA ÚLTIMA REACCIÓN (COMO WHATSAPP WEB)
		const lastReaction = message.reactions[message.reactions.length - 1];

		return (
			<div style={{
				position: 'absolute',
				bottom: '8px',
				right: '8px',
				display: 'flex',
				alignItems: 'center',
				backgroundColor: 'rgba(255, 255, 255, 0.95)',
				borderRadius: '16px',
				padding: '4px 8px',
				boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
				zIndex: 5,
				fontSize: '16px',
				minWidth: '32px',
				justifyContent: 'center'
			}}>
				<span>{lastReaction.type}</span>
			</div>
		);
	};

	// ✅ CORRECCIÓN CRÍTICA: Normalizar imageUrl de forma síncrona y directa
	// El backend envía: /public/flowbuilder-media/company-6/archivo.jpg
	// Debemos construir: http://localhost:8080/public/flowbuilder-media/company-6/archivo.jpg
	// SIN duplicar /public/
	const getImageUrl = () => {
		if (!imageUrl) return "";
		
		const origin = window.location.origin.replace(/\/$/, "");
		let normalizedUrl = imageUrl.trim();
		
		// ✅ Si ya es URL absoluta (http/https/blob), normalizar doble /public/
		if (normalizedUrl.startsWith("http://") || normalizedUrl.startsWith("https://") || normalizedUrl.startsWith("blob:")) {
			// ✅ CORRECCIÓN CRÍTICA: Eliminar TODAS las ocurrencias de doble /public/
			normalizedUrl = normalizedUrl.replace(/\/public\/\/public\//g, '/public/');
			normalizedUrl = normalizedUrl.replace(/\/public\/public\//g, '/public/');
			return normalizedUrl;
		}
		
		// ✅ Si empieza con /public/, construir URL completa
		if (normalizedUrl.startsWith("/public/")) {
			// ✅ CORRECCIÓN CRÍTICA: Eliminar doble /public/ ANTES de construir URL completa
			normalizedUrl = normalizedUrl.replace(/^\/public\/\/public\//, '/public/');
			normalizedUrl = normalizedUrl.replace(/^\/public\/public\//, '/public/');
			return `${origin}${normalizedUrl}`;
		}
		
		// ✅ Fallback: Si NO empieza con /public/, normalizar y construir URL
		let normalizedPath = normalizedUrl.replace(/^\/+/, "");
		normalizedPath = normalizedPath.replace(/^public\//, "");
		return `${origin}/public/${normalizedPath}`;
	};

	const finalImageUrl = getImageUrl();

	return (
		<div style={{ position: 'relative', display: 'inline-block' }}>
			<ModalImage
				className={classes.messageMedia}
				small={finalImageUrl}
				medium={finalImageUrl}
				large={finalImageUrl}
				alt="image"
			/>
			{/* ✅ MOSTRAR REACCIONES SOBRE LA IMAGEN */}
			{renderImageReactions()}
		</div>
	);
};

export default ModalImageCors;
